export default "__VITE_ASSET__DH3nmXN2__"